import { inject, Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/ApiService';
import { Observable } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ITseDetails } from '../interfaces/ITseDetails';
import { ITriggeredTseExport } from '../interfaces/ITriggeredTseExport';
import { IExportStatus } from '../interfaces/IExportStatus';

@Injectable({
  providedIn: 'root'
})
export class FiskalyService {

  private readonly _basePath = '/fiskaly';
  private readonly _apiService = inject(ApiService);

  public getTerminalTseDetails(): Observable<IResponse<ITseDetails>> {
    return this._apiService.get(`${this._basePath}/tse-details`);
  }

  public insertCashPointClosing(): Observable<void> {
    return this._apiService.post(`${this._basePath}/insert-cash-point-closing`);
  }

  public triggerTseExport(): Observable<IResponse<ITriggeredTseExport>> {
    return this._apiService.post(`${this._basePath}/trigger-tse-export`);
  }

  public checkExportStatus(exportId: string): Observable<IResponse<IExportStatus>> {
    return this._apiService.get(`${this._basePath}/check-export-status?exportId=${exportId}`);
  }

  public downloadTseExport(exportId: string): Observable<Blob> {
    return this._apiService.getFile(`${this._basePath}/download-tse-export?exportId=${exportId}`);
  }
}
